<template>
  <div class="titlebar" :style="{ background: backgroundColor }">
    <div class="titlebar-hair"></div>
    <div class="titlebar-body">
      <div
        v-show="displayLeft"
        class="titlebar-body-left"
        @click="iconInvoke('left')"
      ></div>
      <div class="titlebar-body-middle">
        {{ content }}
      </div>
      <div
        v-show="displayRight"
        class="titlebar-body-right"
        @click="iconInvoke('right')"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TitleBar',
  props: {
    content: {
      type: String,
      default: '付款码',
    },
    displayRight: {
      type: Boolean,
      default: true,
    },
    displayLeft: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
  },
  methods: {
    iconInvoke(position) {
      this.$emit(`${position}Invoke`)
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.titlebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  background: transparent;
  width: 100%;
  .flex-column-center();
  &-hair {
    width: 100%;
    height: 20px;
    height: constant(safe-area-inset-top);
    height: env(safe-area-inset-top);
  }
  &-body {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    padding: 0 12px 0 12px;
    &-left {
      width: 22px;
      height: 22px;
      position: absolute;
      left: 12px;
      background-image: url('../assets/img/navback_arrow@3x.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    &-middle {
      flex: 1;
      color: #111111;
      font-family: PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
    }
    &-right {
      .size(22px);
      position: absolute;
      right: 15px;
      background-image: url('../assets/img/more_menu_icon@3x.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}
</style>
